// extracted by mini-css-extract-plugin
export default {"wrapper":"qXt3F","title":"dNpGM","text":"G647j","question":"Bd7rw","no-questions-icon":"l4elQ","questions":"YrtdS","link-mobile":"nOkPs"};